import React, { useEffect, useState } from "react";
import BaseInput from "../../../../components/BaseInput";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import ColorFaces from "../../../../assets/images/faces_color.png";
import "./style.scss";
import PropTypes from "prop-types";
import AnswerTitle from "../AnswerTitle";

const ratingAnswers = [
  { score: 1, isActive: false, isHighlight: false },
  { score: 2, isActive: false, isHighlight: false },
  { score: 3, isActive: false, isHighlight: false },
  { score: 4, isActive: false, isHighlight: false },
  { score: 5, isActive: false, isHighlight: false },
  { score: 6, isActive: false, isHighlight: false },
  { score: 7, isActive: false, isHighlight: false },
  { score: 8, isActive: false, isHighlight: false },
  { score: 9, isActive: false, isHighlight: false },
  { score: 10, isActive: false, isHighlight: false },
];

export default function RatingAnswer({ title, name, onChange, number, value }) {
  RatingAnswer.propTypes = {
    value: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };
  const [ratings, setRatings] = useState(() => ratingAnswers);
  const [isMouseOver, setIsMouseOver] = useState(false);

  useEffect(() => {
    if (value) {
      setRatings((prevState) =>
        prevState.map((rating) => ({
          ...rating,
          isActive: rating.score <= value,
        }))
      );
    }
  }, [value]);

  return (
    <BaseFormBlock>
      <div className="insight-rating-answer">
        <AnswerTitle title={title} number={number} />
        <div className="insight-rating-answer__rating-wrapper">
          {ratings.map((rating) => {
            return (
              <div
                data-score={rating.score}
                onClick={(event) => {
                  // клик почти всегда попадает во вложенные img/цифру, у которых
                  // нет data-score — score нужно читать с самого rate-элемента
                  const score = event.currentTarget.dataset.score;
                  onChange({ target: { value: score, name } });
                  setRatings((prevState) =>
                    prevState.map((rating) => ({
                      ...rating,
                      isActive: rating.score <= score,
                    }))
                  );
                }}
                onMouseLeave={() => {
                  setIsMouseOver(false);
                  setRatings((prevState) =>
                    prevState.map((rating) => ({
                      ...rating,
                      isHighlight: false,
                    }))
                  );
                }}
                onMouseEnter={(event) => {
                  setIsMouseOver(true);
                  const score = event.currentTarget.dataset.score;
                  setRatings((prevState) =>
                    prevState.map((rating) => ({
                      ...rating,
                      isHighlight: rating.score <= score,
                    }))
                  );
                }}
                key={rating.score}
                className="insight-rating-answer__rate"
                style={{
                  filter: `saturate(${
                    (isMouseOver ? rating.isHighlight : rating.isActive) ? 1 : 0
                  })`,
                }}
              >
                <img src={ColorFaces} alt="gray_faces" />
                <div>{rating.score}</div>
              </div>
            );
          })}
        </div>
      </div>
    </BaseFormBlock>
  );
}
